module.exports = __webpack_public_path__ + "img/increment.06b07bb6.svg";